import React from 'react';
import { Typography, Box } from '@mui/material';
import { Button } from 'system/atoms';
import { Header } from 'components/Header';
import {
  layoutContainerPaddingBottom,
  layoutContainerPaddingTop,
  layoutContainerPaddingX
} from 'services/navigation/components/PrivateRoute';

const ContactSupport = () => {
  const handleEmailClick = () => {
    window.location.href = 'mailto:support@joinpopp.com';
  };

  return (
    <Box
      sx={{
        textAlign: 'left',
        pt: layoutContainerPaddingTop,
        pb: layoutContainerPaddingBottom,
        px: layoutContainerPaddingX
      }}
    >
      <Header
        title="Contact Support"
        prevPageTitle="Support"
        subtitle="Contact us"
      />

      <Box marginTop={3}>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          If you have any questions or need assistance, our support team is here
          to help. You can reach out to us at any time by emailing
          <Typography
            component="span"
            variant="body1"
            color="primary"
            sx={{ fontWeight: 'bold', marginLeft: 1 }}
          >
            support@joinpopp.com
          </Typography>
          .
        </Typography>
        <Button variant="primary" onClick={handleEmailClick}>
          Email Support
        </Button>
      </Box>
    </Box>
  );
};

export default ContactSupport;
